import { QuilttConnector } from '@quiltt/react-native';
import { useLocalSearchParams } from 'expo-router';
import React from 'react';

import { getAppOrigin } from '../../common/misc';
import { QUILTT_CONNECTOR_ID } from '../../config/config';
import { IS_PRODUCTION } from '../../config/FruitfulEnvironment';
import { getWebUrl } from '../../lib/Web';
import useQuilttConnectorCallbacks from '../hooks/useQuilttConnectorCallbacks';
import type { QuilttConnectorSource } from '../types/Quiltt';

const Quiltt = () => {
    const { connectionId, context } = useLocalSearchParams<{
        connectionId?: string;
        context?: QuilttConnectorSource;
    }>();

    const { onEvent, onExit, onExitError, onExitSuccess } =
        useQuilttConnectorCallbacks(context);

    const oauthRedirectUrl = IS_PRODUCTION
        ? `${getWebUrl()}/oauth/quiltt`
        : `${getAppOrigin()}oauth/quiltt/`;

    return (
        <QuilttConnector
            connectorId={QUILTT_CONNECTOR_ID}
            connectionId={connectionId ?? undefined}
            oauthRedirectUrl={oauthRedirectUrl}
            onEvent={onEvent}
            onExit={onExit}
            onExitError={onExitError}
            onExitSuccess={onExitSuccess}
        />
    );
};

export default Quiltt;
